import { useContext, useState } from 'react';

import { Col, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import hocFrom from '../../../components/forms/HocFrom';
import InputControl from '../../../components/inputs/InputControl';
import InputControlMulti from '../../../components/inputs/InputControlMulti';
import InputFarsi from '../../../components/inputs/InputFarsi';
import InputNumber from '../../../components/inputs/InputNumber';
import Switchrs from '../../../components/inputs/Switchrs';
import Loader from '../../../components/layout/Loader';
import Mobilecheckexist from '../../../components/inputs/Mobilecheckexist';
import ChangeNumberForm from '../../forces/worker/ChangeNumberForm';
import DashboardContext from '../../../Context';

function FormUser({
  handelUpdataFrom,
  handelSend,
  loding,
  handelLoadingform,
  LoadingForm,
  dataUpdate,
  handelsetdataForm,
  formdata,
  info,
}) {
  const [statusMobile, setstatusMobile] = useState(false);

  const handelstatusmobile = (status) => setstatusMobile(status);

  const { changeNumber } = useContext(DashboardContext);

  const handleValue = (name, value) => {
    switch (name) {
      case 'referrerId':
        handelsetdataForm({ ...formdata, referrerId: value });
        break;
      case 'userName':
        handelsetdataForm({ ...formdata, userName: value });
        break;
      case 'lastName':
        handelsetdataForm({ ...formdata, lastName: value });
        break;
      case 'firstName':
        handelsetdataForm({ ...formdata, firstName: value });
        break;
      case 'secondaryCellPhone':
        handelsetdataForm({ ...formdata, secondaryCellPhone: value });
        break;
      case 'nationalCode':
        handelsetdataForm({
          ...formdata,
          nationalCode: value === '' ? null : value,
        });
        break;
      case 'tell':
        handelsetdataForm({ ...formdata, tell: value });
        break;
      case 'roleIds':
        handelsetdataForm({ ...formdata, roleIds: value });
        break;
      case 'isActiveFormUser':
        handelsetdataForm({ ...formdata, isActive: value });
        break;
      case 'sendSMS':
        handelsetdataForm({ ...formdata, sendSMS: value });
        break;
      case 'description':
        handelsetdataForm({ ...formdata, description: value });
        break;
      default:
        break;
    }
  };

  const handelSubmit = (event) => {
    event.preventDefault();
    handelLoadingform(true);
    if (
      !formdata.referrerId ||
      formdata.referrerId === '00000000-0000-0000-0000-000000000000'
    ) {
      toast.error(' لطفا نحوه اشنایی  را  انتخاب کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (!formdata.userName) {
      toast.error(' لطفا نام کاربری را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (statusMobile === true) {
      toast.error(' نام کاربری (شماره موبایل) قبلا ثبت شده است', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (!formdata.lastName) {
      toast.error(' لطفا نام خانوادگی را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (!formdata.firstName) {
      toast.error(' لطفا نام را وارد کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (!formdata.roleIds) {
      toast.error(' لطفا نقش کاربر را انتخاب کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else {
      dataUpdate.userName ? handelUpdataFrom() : handelSend();
    }
  };

  return (
    <>
      {loding ? (
        <Loader />
      ) : changeNumber ? (
        <ChangeNumberForm info={info} />
      ) : (
        <Form>
          <Form.Row>
            <Col>
              <InputControl
                url='/referrer/dropdown'
                label='نحوه آشنایی'
                name='referrerId'
                handelValue={handleValue}
                defaultValue={dataUpdate.referrerId}
              />
            </Col>
            <Col>
              <Mobilecheckexist
                urlPorfile='Customer'
                handelstatusmobile={handelstatusmobile}
                label='نام کاربری (شماره موبایل)'
                name='userName'
                handelValue={handleValue}
                defaultValue={dataUpdate.userName}
                disabled={dataUpdate.id}
              />
            </Col>
            <Col>
              <Mobilecheckexist
                urlPorfile='Customer'
                label='شماره موبایل دوم'
                name='secondaryCellPhone'
                handelValue={handleValue}
                defaultValue={dataUpdate.secondaryCellPhone}
                // disabled={dataUpdate.id}
              />
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <InputFarsi
                label='نام'
                name='firstName'
                handelValue={handleValue}
                defaultValue={dataUpdate.firstName}
              />
            </Col>
            <Col>
              <InputFarsi
                label='نام خانوادگی'
                name='lastName'
                handelValue={handleValue}
                defaultValue={dataUpdate.lastName}
              />
            </Col>
            <Col>
              <InputNumber
                name='nationalCode'
                label='کدملی'
                defaultValue={dataUpdate.nationalCode}
                maxLength='10'
                handelValue={handleValue}
              />
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <InputNumber
                label='شماره  تلفن ثابت'
                name='tell'
                maxLength='8'
                handelValue={handleValue}
                defaultValue={dataUpdate.tell}
              />
            </Col>
            <Col>
              <InputControlMulti
                url='/roles/roledropdown'
                label='نقش کاربر'
                name='roleIds'
                // disabled={dataUpdate.id&&!userPage}
                handelValue={handleValue}
                defaultValue={dataUpdate.roleIds}
              />
            </Col>
            <Col lg='12' md='12' sm='12' xs='12'>
              <div className='form-group'>
                <label for='descriptionTextarea'>توضیحات</label>
                <textarea
                  className='form-control'
                  id='descriptionTextarea'
                  rows='6'
                  defaultValue={dataUpdate ? dataUpdate.description : ''}
                  onChange={(e) => handleValue('description', e.target.value)}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Switchrs
              label='آیا فعال باشد؟'
              name='isActiveFormUser'
              handelValue={handleValue}
              checke={formdata.isActive}
            />
            <Switchrs
              label='آیا برای این کاربر، پیامک های مربوط به سفارش ارسال شود؟'
              name='sendSMS'
              handelValue={handleValue}
              checke={formdata.sendSMS}
            />
          </Form.Row>
          <Form.Row>
            <Col>
              <button
                type='submit'
                className='btn btn-success'
                onClick={handelSubmit}
                disabled={LoadingForm}
              >
                {LoadingForm ? (
                  <i className='fa fa-spinner fa-pulse fa-fw'></i>
                ) : dataUpdate.userName ? (
                  'ثبت ویرایش'
                ) : (
                  'ثبت'
                )}
              </button>
            </Col>
          </Form.Row>
        </Form>
      )}
    </>
  );
}
export default hocFrom(FormUser);
